export default async function useApi(
  url: string,
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  body?: any,
  isForm?: boolean,
  tenantId?: string,
  hasNoAuth?: boolean,
  customToken?: string
) {
  const { apiBaseUrl } = useAppConfig()
  const { user, logout } = useUserStore()
  const { $i18n } = useNuxtApp()
  const t = (key: string) => ($i18n as any).t(key)

  try {
    const response = await $fetch<any>(`${apiBaseUrl}${url}`, {
      method,
      headers: {
        accept: 'application/json',
        'X-Tenant': `${tenantId || user.tenant_identifier}`,
        ...(hasNoAuth
          ? {}
          : {
              Authorization: `Bearer ${customToken || user.api_token}`
            }),
        ...(body && !isForm ? { 'Content-Type': 'application/json' } : {})
      },
      body: isForm ? body : JSON.stringify(body)
    })

    return response
  } catch (error: any) {
    if (error?.statusCode === 401 || error?.response?.status === 401) {
      await logout()
      return {}
    }

    const errorFields = error?.data?.errors || { message: [error?.data?.message ?? ''] }

    Object.keys(errorFields).forEach((field) => {
      showErrorToast({
        summary: t('global.error'),
        detail: errorFields?.[field]?.[0] || t('global.errors.networkError')
      })
    })
  }
}
